// ------ PRODUCT ACTIONS START ------ //
export const UPDATE_PID = "product/update/pid";
export const UPDATE_XY = "product/update/location";
export const UPDATE_TS = "product/update/ts";
export const UPDATE_ACTIVE_TEST_ID = "product/update/activeTestId";
export const UPDATE_FIXATION_VALUE = "product/update/fixation";
export const UPDATE_WARNING = "product/update/warning";
export const UPDATE_STATUS = "product/update/status";
export const UPDATE_BATTERY = "product/update/battery";
export const UPDATE_CONTROLLERS = "product/update/controllers";
export const UPDATE_CONTROLLER_BATTERY = "product/update/controllerBattery";
export const UPDATE_CONTROLLER_RECONNECT_PROMPT = "product/update/controllerReconnectPrompt";
export const UPDATE_CURRENT_VERSION = "product/update/currentVersion";
export const UPDATE_IS_EYE_TRACKING_ON = "product/update/isEyeTrackingOn";
export const UPDATE_SCENE = "product/update/scene";
export const UPDATE_ON_TEST_PROGRESS_PAGE = "product/update/testProgressPage";
export const UPDATE_DEVICE_STATUS = "product/update/deviceStatus";
export const UPDATE_PATIENT_ACTION = "product/update/patientAction";
export const REQUEST_CONTROLLER_RECONNECT = "product/request/controllerReconnect";
export const UPDATE_VOLUME = "product/update/volume";
export const CLEAR_TEST_PROGRESS = "product/clear/testProgress";
export const BATCH_UPDATE = "product/batchUpdate";
export const RESET_PRODUCT_STATE = "product/reset/state";
export const UPDATE_PRODUCT_SCOPE = "product/update/scope";
export const SET_LATEST_TEST_INTERACTION_DATE = "product/update/latestTestInteractionDate";
export const CLEAR_AWAITING_MENU_SCENE = "product/clear/awaitingMenuScene";
// ------ PRODUCT ACTIONS END ------ //

// ------ USER ACTIONS START ------ //
export const USER_SET_ROLE = "user/set/role";
export const USER_SET_ORG = "user/set/org";
export const USER_SET_IS_ACTIVE = "user/set/isActive";
export const USER_SET_FORCE_PASS_CHANGE = "user/set/forcePassChange";
export const USER_SET_LOG_OUT = "user/set/logOut";
export const USER_REQUEST_SUBMISSIONS = "user/request/submissions";
export const USER_SET_SUBMISSIONS = "user/set/receivedSubmissions";
export const USER_SET_DISTRIBUTOR_ID = "user/set/distributorId";
export const USER_APPROVE_OR_DENY_SUBMISSION = "user/approveOrDenySubmission";
export const USER_CANCEL_SUBMISSION = "user/cancel/submission";
export const USER_SET_ONBOARDING = "user/set/onboarding";
// ------ USER ACTIONS END ------ //

// ------ DIALOG ACTIONS START ------ //
export const OPEN_CONFIRMATION = "dialog/open/confirmation";
export const CLOSE_CONFIRMATION = "dialog/close/confirmation";
export const UPDATE_DRAWER_NO = "dialog/drawer/drawerNo";
// ----- DIALOG ACTIONS END ------ //

// ------ APP ACTIONS START ------ //
export const RESET_STATE = "RESET_STATE";
